import React, { useImperativeHandle, useState } from "react";
import styles from "./index.module.scss";

export interface CountDownInstance {
    count(time: number): Promise<void>;
}

export default React.forwardRef<CountDownInstance>(({}, ref) => {
    const [count, setCount] = useState(0);

    useImperativeHandle(ref, () => ({
        count(time: number) {
            return new Promise(resolve => {
                let count = time;

                setCount(count);

                const timeout = setInterval(() => {
                    setCount(--count);
                    if (count === 0) {
                        clearInterval(timeout);
                        resolve();
                    }
                }, 1000);

                return () => clearInterval(timeout);
            });
        }
    }));

    if (count === 0) return null;
    return <div className={styles.root}>{count}</div>;
});
